import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { DepartmentStore } from '@iq-central-front-end/share';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {
  DashboardFilter,
  InitialDashboardFilter,
} from '../interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  constructor(
    private http: HttpClient,
    private departmentStore: DepartmentStore
  ) { }

  createDepartment(payload) {
    this.departmentStore.setLoading(true);
    this.departmentStore.clearError();

    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createDepartment}`,
      payload
    ).pipe(
      tap((response) => {
        if (response['responseResult']) {
          this.departmentStore.addDepartment(response['responseResult'][0]);
        }
        this.departmentStore.setLoading(false);
      }),
      catchError((error) => {
        this.departmentStore.setError(error.message || 'An error occurred');
        this.departmentStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  updateDepartment(id, payload) {
    this.departmentStore.setLoading(true);
    this.departmentStore.clearError();

    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateDepartment}/${id}`,
      payload
    ).pipe(
      tap((response) => {
        if (response['responseResult']) {
          this.departmentStore.updateDepartment(response['responseResult']);
        }
        this.departmentStore.setLoading(false);
      }),
      catchError((error) => {
        this.departmentStore.setError(error.message || 'An error occurred');
        this.departmentStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  getAllDepartments(filterParam?: DashboardFilter) {
    const hasExistingData = this.departmentStore.departments$()?.length > 0;
    if (!hasExistingData) {
      this.departmentStore.setLoading(true);
    }

    this.departmentStore.clearError();

    if (!filterParam) {
      filterParam = InitialDashboardFilter;
    }

    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.getAllDepartments}`,
      filterParam
    ).pipe(
      tap((response) => {
        this.departmentStore.setDepartments(response['responseResult']);
        this.departmentStore.setLoading(false);
      }),
      catchError((error) => {
        this.departmentStore.setError(error.message || 'An error occurred');
        this.departmentStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  deleteDepartment(departmentId) {
    this.departmentStore.setLoading(true);
    this.departmentStore.clearError();

    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteDepartment}/${departmentId}`
    ).pipe(
      tap(() => {
        this.departmentStore.deleteDepartment(departmentId);
        this.departmentStore.setLoading(false);
      }),
      catchError((error) => {
        this.departmentStore.setError(error.message || 'An error occurred');
        this.departmentStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }
}
